import { buildSemesterColumns } from "./buildSemesterColumns";
import { getTrayectoById, getTrayectosSorted } from "./curriculumMalla";

/**
 * Flat map keyed by `${semestre}:${trayectoId}` for lists / debugging.
 */
export function buildMallaCellMap(materias, meta) {
  const map = {};

  materias.forEach((m) => {
    const key = `${m.Semestre}:${m.Trayecto}`;
    if (!map[key]) {
      map[key] = { materias: [], span: 1 };
    }
    map[key].materias.push(m);
    if (m.SpanTrayectos > 1) {
      map[key].span = m.SpanTrayectos;
    }
  });

  Object.keys(map).forEach((key) => {
    map[key].materias.sort((a, b) => a.Orden - b.Orden);
    const trayecto = getTrayectoById(meta, map[key].materias[0]?.Trayecto);
    map[key].trayecto = trayecto;
  });

  return map;
}

export function buildMallaGridModel(materias, meta) {
  const trayectos = getTrayectosSorted(meta);
  return {
    columns: buildSemesterColumns(materias, meta),
    rowCount: trayectos.length,
    trayectos,
    semestres: meta.semestres,
    fases: meta.fases,
  };
}
